@if (
  appsEc.plugins.currentEntityPlugin.feature.selectors
    .getEditedEntity()
    .asSignal()
) {
  @let submissionError =
    appsEc.plugins.editingPlugin.feature.selectors.submissionError.asSignal();
  <atn-ds-centered-overlay type="full-width">
    <div class="atn-editing-app-dialog">
      <atn-ds-widget [title]="titleSg()">
        <div actions>
          <i
            class="atn-icon atn-close atn-red"
            (click)="cancelClickHandler()"
          ></i>
        </div>
        <div class="atn-editing-app-dialog__body">
          <atn-ds-integrated-horizontal-tabs
            class="atn-editing-app-dialog__tabs"
          >
            <ng-template
              atnDsTab
              name="General"
            >
              <atn-app-general-tab />
            </ng-template>

            <ng-template
              atnDsTab
              name="Variables"
            >
              <atn-variables-builder />
            </ng-template>
          </atn-ds-integrated-horizontal-tabs>
          @if (submissionError) {
            <div class="atn-editing-app-dialog__error">
              <atn-admin-error-message [message]="submissionError" />
            </div>
          }
        </div>
        <div
          class="atn-editing-app-dialog__footer"
          footer
        >
          <atn-ds-button
            type="transparent"
            (click)="cancelClickHandler()"
          >
            Cancel
          </atn-ds-button>
          <atn-ds-button (click)="saveClickHandler()"> Save </atn-ds-button>
        </div>
      </atn-ds-widget>
    </div>
  </atn-ds-centered-overlay>
}
